import { useEffect, useState } from "react";
import api from "@/lib/api";
import { X } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const DISMISS_KEY = "stb_promo_dismissed_v1";

/** Sitewide advertisement banner — sits at the very top of the page.
 *  Admin uploads one active image via /admin/promo-banner. If the user
 *  dismisses it, we remember that per-banner in localStorage. */
export default function PromoBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    api.get("/promo-banner").then((r) => setBanner(r.data?.banner || null)).catch(() => {});
  }, []);

  if (!banner) return null;
  // Per-banner dismissal key so a NEW upload re-appears
  const dismissed = typeof window !== "undefined" && localStorage.getItem(`${DISMISS_KEY}_${banner.id}`);
  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(`${DISMISS_KEY}_${banner.id}`, "1"); } catch { /* ignore */ }
    setBanner(null);
  };

  const inner = (
    <img
      src={`${BACKEND}${banner.image_url}`}
      alt="Promo"
      className="max-h-[180px] max-w-full h-auto w-auto object-contain"
      data-testid="promo-banner-image"
    />
  );

  return (
    <div className="relative w-full bg-secondary/40 border-b border-border" data-testid="promo-banner">
      <div className="max-w-5xl mx-auto flex items-center justify-center py-2 px-6">
        {banner.link_url ? (
          <a href={banner.link_url} target="_blank" rel="noopener noreferrer" data-testid="promo-banner-link" className="inline-block">
            {inner}
          </a>
        ) : inner}
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid="promo-banner-dismiss"
        className="absolute top-2 right-2 w-8 h-8 bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
